import React, {useEffect} from 'react';
import {Card, Form, Space, Typography} from "antd";
import {useDispatch, useSelector} from "react-redux";
import ModalRepayment from "./ModalRepayment";
import IntlMessages from "../../util/IntlMessages";
import {getAuthUserReducer} from "../../appRedux/actions/Auth";

const FormPersonalData = () => {

    const dispatch = useDispatch()
    const {authUser} = useSelector(state => state.auth)

    // authUser is loaded once at app start; purchases change the balance and the credit
    // on the server, so reload them every time the page is opened.
    useEffect(() => {
        dispatch(getAuthUserReducer())
    }, [dispatch])

    const formItemLayout = {
        labelCol: {
            xs: {span: 24},
            sm: {span: 8},
        },
        wrapperCol: {
            xs: {span: 24},
            sm: {span: 16},
        },
    };

    return (
        <Card className="gx-card" title={<IntlMessages id="account.formPersonalData.formPersonalData"/>}>
            <Form
                {...formItemLayout}
            >
                <Form.Item
                    label={<IntlMessages id="account.formPersonalData.email"/>}
                >
                    <span className='gx-d-block'>{authUser.email}</span>
                </Form.Item>
                <Form.Item
                    label={<IntlMessages id="account.formPersonalData.currentBalance"/>}
                >
                    <span className='gx-d-block'>{authUser.balance}</span>
                </Form.Item>
                {
                    authUser.is_staff && !authUser.is_superuser &&
                    <Form.Item
                        label={<IntlMessages id="account.formPersonalData.creditBalance"/>}
                    >
                        <Space>
                            <Typography.Text style={{color: '#e0e0e0'}}>
                                {authUser.credit}
                            </Typography.Text>
                            <ModalRepayment amount={authUser.credit}/>
                        </Space>
                    </Form.Item>
                }
            </Form>
        </Card>
    );
};

export default FormPersonalData;